import * as z from "zod";

export const unlinkMerchantPhone = {
  name: "unlinkMerchantPhone" as const,
  input: z.null(),
  output: z.object({ unlinked: z.boolean() }),
};
